// assets
import ScheduleOutlined from '@ant-design/icons/ScheduleOutlined';

// icons
const icons = { ScheduleOutlined };

// ==============================|| MENU ITEMS - FARM MANAGEMENT ||============================== //

const farmManagement = {
  id: 'group-farm-management',
  title: 'Farm Management',
  type: 'group',
  children: [
    {
      id: 'farm-management',
      title: 'Batches',
      type: 'item',
      url: '/farm-management',
      icon: icons.ScheduleOutlined,
      breadcrumbs: false
    }
  ]
};

export default farmManagement;
